import { ChangeDetectionStrategy, ChangeDetectorRef, Component, ElementRef, HostBinding, HostListener, ViewChild } from '@angular/core';
import { ActivatedRoute, ParamMap } from '@angular/router';
import { WizGroupCommand, WizRoot, WizEventManager } from '@wizeoo/akm-component-lib';
import { DisplayGrid, GridsterComponent, GridsterItem, GridType } from 'angular-gridster2';
import { Subscription } from 'rxjs';
import { AlkEvent, ChronocodeCmd, FindConnectCommand, FindCssRenderCommand, FindFormatCommand, FindMeasureCommand, FindScenariiCommand, FindStyleCommand, GridsterWidget, PDF_PAGE_KIND, PDFPage, PhysicalTemplateCmd, PhysicalTemplateVO, StyleEngine, TabVO, VisionStepPerimeterCommand, WIDGET_KIND, WorkcomCall } from '@wizeoo/akm-common-lib';
import { BaseView } from '@wizeoo/akm-common-lib';
import { Model } from 'src/app/model/model';
import { ViewData } from '@wizeoo/akm-common-lib';
import { RoleVO } from '@wizeoo/akm-common-lib';
import { ALK_EVENT_TYPE, FEATURE_KIND, throttleable } from '@wizeoo/akm-common-lib';
import { UserApplicationVO } from '@wizeoo/akm-common-lib';
import { PermissionAccess, PermissionVisibility, StaticFeatureEnum } from '@wizeoo/akm-common-lib';
import { FreedataCall } from '@wizeoo/akm-common-lib';
import { VisionStep } from '@wizeoo/akm-message-lib';
import { BaselineEngine } from '@wizeoo/akm-compute-lib';

@Component({
  selector: 'user-tab-view',
  templateUrl: './user-tab.view.html',
  changeDetection: ChangeDetectionStrategy.OnPush,
})
export class UserTabView extends BaseView {
  
  @HostListener('window:resize')
  @throttleable(100)
  onWindowResize(): void {
    setTimeout(() => {
      this.optimizeHeight();
    }, 0);
    
  }

  @HostBinding('style.background-color') get backColor(): string {
    return this.backgroundColor;
  }

  @ViewChild('meGridster') meGridster: GridsterComponent // zone de dessin gridster

  public backgroundColor = StyleEngine.STYLE_DEFAULT_VIEW_BACKGROUND_COLOR; // --grid-header-background-color

  // Options par défaut pour satisfaire GridSter
  private _options: any = null;
  public get options(): any {
    if(!this._options) {
      this._options = Model.getInstance().physicalTemplateEngine.gridsterOption();
      // this._options.minCols = 0;
      // this._options.minRows = 0;
      this._options.minItemCols = 0;
      this._options.minItemRows = 0;
      // console.log("set option by default");
    }
    return this._options;
  } 

  public set options(value: any) {
    if(value) {
      this._options = value;
      // this._options.minCols = 0;
      // this._options.minRows = 0;
      // this._options.minItemCols = 0;
      // this._options.minItemRows = 0;
    } else {
      console.log("set options null");
    }
    // console.log('height', this._options);
  }



  private template: PhysicalTemplateVO = null;

  private _tabSubscriber: Subscription = null; // écouteur sur changement de tab

  private _currentTab: TabVO = null; // onglet de vue cible
  public get currentTab(): TabVO {
    return this._currentTab;
  }
  public set currentTab(value: TabVO) {
    this._currentTab = value;
    this.feedTab();
  }

  public tabWidgets: GridsterWidget[]; // la liste des widgets de cette vue

  /** si pas de bordures, pas de shadow */
  public notshadowed(item: GridsterWidget): boolean {
    return !!item?.hideBorders;
  }

  /** injection correcte du GiVO dans les widgets... Cette merde de Gridster flingue les getter / setters */
  public getRealVOFromGridsterLimitation(item: GridsterWidget): GridsterWidget {
    let res: GridsterWidget = null;
    this.tabWidgets.forEach((givo: GridsterWidget) => {
      if (givo.uid === item.uid) {
        res = givo;
      }
    });
    return res;
  }

  public userVisionStep: VisionStep; // le step du User, pour alimentation de N-relative

  constructor(public route: ActivatedRoute, public elementRef: ElementRef, private cdref: ChangeDetectorRef) {
    super(elementRef);
  }

  wizBeforeInit() {
    const calls = [];
    // tout le reste est chargé sur InitApp

    if (!Model.getInstance().chronocodeEngine.getChronocodesMap()) {
      // disponibilité des chronocodes pour labels
      calls.push(new ChronocodeCmd(Model.getInstance()).find());
    }
    // disponibilité des freedatas pour labels
    if (!Model.getInstance().freedataEngine.getFreedataMap()) {
      calls.push(new FreedataCall(Model.getInstance()));
    }
    if (!Model.getInstance().measureEngine.getMeasureList()) {
      // vérification des measures
      calls.push(new FindMeasureCommand(Model.getInstance()));
    }

    // disponibilité des scenarii
    if (!Model.getInstance().scenariiMap) {
      calls.push(new FindScenariiCommand(Model.getInstance()));
    }

    const physOK: boolean = Model.getInstance().physicalTemplateMap?.get(Model.getInstance().businessUnitCode)?.has(Model.getInstance().visionCode);

    if (!physOK) {
      calls.push(new PhysicalTemplateCmd(Model.getInstance()).find());
    }

    if (!Model.getInstance().styleList) {
      calls.push(new FindStyleCommand(Model.getInstance()));
    }
    if (!Model.getInstance().connectMapExt) {
      // chargement de la liste des fonctions de connexion
      calls.push(new FindConnectCommand(Model.getInstance()));
    }
    // chargement de la liste des formats
    if (!Model.getInstance().formatEngine.getFormatList()) {
      // double appel pour format de base à la bu (*)
      calls.push(new FindFormatCommand(Model.getInstance()).find(ViewData.wildcardDomain, ViewData.wildcardDomain));
      calls.push(new FindFormatCommand(Model.getInstance()).find(Model.getInstance().domainCode, Model.getInstance().businessUnitCode));
    }

    // chargement de la liste des rendus css
    if (!Model.getInstance().styleEngine.getCssRenderList()) {
      calls.push(new FindCssRenderCommand(Model.getInstance()).find(Model.getInstance().domainCode, Model.getInstance().businessUnitCode));
    }

    // vsp pas encore chargés
    if (!Model.getInstance().visionEngine.getStepPerimeterList(Model.getInstance().currentVision)) {
      calls.push(new VisionStepPerimeterCommand(Model.getInstance()).find(Model.getInstance().currentVision, true));
    }

    // chargement des messages
    if (!Model.getInstance().workflowEngine.getWorkcomMap()) {
      calls.push(new WorkcomCall(Model.getInstance()));
    }

    // // chargement des messages
    // if (!Model.getInstance().workcomList) {
    //   calls.push(new FindWorkComCommand(Model.getInstance()));
    // }    

    if (calls.length > 0) {
      return new WizGroupCommand().configure(calls);
    } else {
      return true;
    }
  }

  wizAddListener() {
    super.wizAddListener();
    WizEventManager.addListener(this, WizRoot.root(), ALK_EVENT_TYPE.SELECT_VISION, this.feedTab); // modification de la portée vision au niveau de l'appli, rechargement  
    WizEventManager.addListener(this, WizRoot.root(), ALK_EVENT_TYPE.PDF_PRINT_REQUEST, this.generatePDF);
  }

  wizRemoveListener() {
    super.wizRemoveListener();
    WizEventManager.removeListener(this, WizRoot.root(), ALK_EVENT_TYPE.SELECT_VISION);
    WizEventManager.removeListener(this, WizRoot.root(), ALK_EVENT_TYPE.PDF_PRINT_REQUEST);
  }

  wizSynchronizeData() {
    this.resolveTab(this.route.snapshot.paramMap);

    this.route.paramMap.subscribe((p) => {
      this.resolveTab(p);
    });

    this.applyGridsterConfig();
  }

  private resolveTab(params: ParamMap): void {
    const tabCode: string = params.get('code');
    this.currentTab = Model.getInstance().tabEngine.getTabByCode(Model.getInstance().visionCode + ViewData.KEY_SEPARATOR + tabCode);
  }

  /**
   * alimentation du bon TabVO depuis le tabManager
   * @param tab le currentTab du tabManager
   */
  private feedTab(): void {
    // console.log('feedTab', this.currentTab, this.currentTab.visionCode, Model.getInstance().visionCode);
    if (this.currentTab && this.currentTab.visionCode === Model.getInstance().visionCode) {
      this.resolveUserVisionStep(); // alimentation du step cible du user

      const physTempVO: PhysicalTemplateVO = Model.getInstance().physicalTemplateEngine.getTemplate(this.currentTab.physTempCode); // collecte du template source
      this.template = physTempVO; // alimentation du template
      
      if (!!this.template.color) {
        this.backgroundColor = this.template.color;
      } else {
        this.backgroundColor = StyleEngine.STYLE_DEFAULT_VIEW_BACKGROUND_COLOR;
      }
      
      
      this.applyGridsterConfig();
      const allowedWidgets = physTempVO?.widgets || this.currentTab.widgets;

      // TODO ici, prendre en compte les widgets FD et les permission sur les FD

      // L'utiliseur peut voir uniquement les widgets sur lesquels il a les droits pour le pool de données
      const permissionCkeched:  GridsterWidget[] = [];

      allowedWidgets.forEach((givo: GridsterWidget) => {
        
        const visionCodeReal: string = Model.getInstance().visionCode;
        // const visionCode: string = givo.wco.v;
        const stepCode: string = visionCodeReal + ViewData.KEY_SEPARATOR + givo.wco.vs;
        const itemFd: boolean = !!givo.wco.fdk; // TODO dans ce cas, droits sur FDs...
        // console.log('check', visionCodeReal, visionCode, stepCode, itemFd);
        
        const canReadStep: boolean = Model.getInstance().permissionEngine.canRead(stepCode);
        const canReadVision: boolean = Model.getInstance().permissionEngine.canRead(visionCodeReal);
        const canReadFd: boolean = (Model.getInstance().permissionEngine.hasAnyPermission({feature: StaticFeatureEnum.FREEDATA, // ou des droits sur les FDs
        accesses: [PermissionAccess.CREATE, PermissionAccess.UPDATE],
        visibility: PermissionVisibility.DISABLED }) && !!itemFd);
        
        // console.log('checkPerms', canReadStep, canReadVision, canReadFd);
        if (canReadStep || canReadVision || canReadFd) {
          if(!!givo.wco.hidden) {
            // console.log('userTab hidden', givo, this._options);
            givo.x = -1;
            givo.rows = -1;  
            givo.cols = 0;
            givo.rows = 0;  
          }
          permissionCkeched.push(givo);       
                                  
        } 
      });

      this.tabWidgets = permissionCkeched;
      
      // calcul des indices. Va dispatcher un event pour maj éventuelle des entêtes de widgets
      Model.getInstance().physicalTemplateEngine.resetIndices(this.tabWidgets);
      // alimentation de la map de widget de l'engine
      Model.getInstance().widgetEngine.widgetConfigMap = new Map(this.tabWidgets.map((givo: GridsterWidget) => [givo.uid, givo]));

      // TODO TODO prise du max col et max rows
      // console.log("maxs", this.tabWidgets);

    } else {
      // sinon on rince
      this.userVisionStep = null;
      this.tabWidgets = [];
    }

    this.applyGridsterConfig(); // refresh de la conf
    this.cdref.markForCheck();
  }

  private applyGridsterConfig(): void { 
    
        // fit & verticalScroll, même combat, sauf que Fit s'adapte en hauteur sur resize pour prendre toute la hauteur si possible
    let finalType: GridType = ViewData.DEFAULT_SCREEN_MODE;
    if(this.template?.screenMode) {
      if(this.template.screenMode === GridType.Fit) {
        finalType = GridType.VerticalFixed;
      } else {
        finalType = this.template.screenMode as GridType;
      }
    }
    this.options.gridType = finalType; // this.template?.screenMode || 
    this.options.outerMargin = false;
    this.options.draggable.enabled = false;
    this.options.resizable.enabled = false;
    this.options.displayGrid = DisplayGrid.None;
    this._options.minCols = 0;
    this._options.minRows = 0;
    this._options.minItemCols = 0;
    this._options.minItemRows = 0;
    this._options.minItemArea = 0;
    
    
    // console.log('applygrid', this.options, this.meGridster);
    //if(!!this.options?.api) {    
      //this.options.gridType = this.template?.screenMode || PhysicalTemplateManager.DEFAULT_SCREEN_MODE;
      // this.options.minCols = 10;
      // this.options.minRows = 10;
    this.optimizeHeight();

  }

  /** détermination du step à injecter dans les widgets */
  private resolveUserVisionStep(): void {
    this.userVisionStep = null;

    // collecte des droits sur la vision
    const visionApp: UserApplicationVO = Model.getInstance().userEngine.getUserApp(
      Model.getInstance().connectedUser,
      Model.getInstance().domainCode,
      Model.getInstance().businessUnitCode,
      Model.getInstance().visionCode
    );
    const rolesStep: RoleVO[] = visionApp
      ? visionApp.rolesVO.filter((r) => r.withFeature && !!r.feature && r.feature.kind === FEATURE_KIND.VISION_STEP)
      : [];

    if (!!rolesStep && rolesStep.length > 0) {
      // console.log('roles', rolesStep);
      this.userVisionStep = rolesStep.reduce((maxStep: VisionStep, r: RoleVO) => {
        // TODO, contrôler que c'est la bonne vision
        const stepKey: string = r.featureCode.split(ViewData.KEY_SEPARATOR)[1];
        const step: VisionStep = Object.values(Model.getInstance().currentVision.visionSteps).find((vs) => vs.code === stepKey);
        if (!maxStep || maxStep.level < step.level) {
          return step;
        } else {
          return maxStep;
        }
      }, null);
    } else {
      this.userVisionStep = BaselineEngine.getVisionStepByLevel(Model.getInstance().currentVision, 1);
    }
  }

  wizOnDestroy() {
    // console.log('feedTab', this.currentTab);
    if (this._tabSubscriber) {
      this._tabSubscriber.unsubscribe();
    }
  }

  /** s'il reste de la place en bas, on remplit, sauf si mode fixe */
  private optimizeHeight(): void {

    // pas de gridster ou pas de widgets
    if(!this.meGridster || !(this.tabWidgets?.length > 0)) {
      return;
    }

    // if(this.template?.screenMode === GridType.Fixed) {
    //   return;
    // }

    if(this.template?.screenMode !== GridType.Fit) {
      this.options.api.optionsChanged();
      return;
    }

    let totalHeight: number = this.meGridster?.curHeight;

    let maxRow: number = 0;
    this.tabWidgets.forEach(gw => {
      if(!gw.wco.hidden) {
        let widgetRow: number = gw.y + gw.rows;
        maxRow = Math.max(maxRow, widgetRow);
      } else {
        // console.log('hidden', gw);
      }
    });

    // console.log('fit', totalHeight, maxRow);

    let currentRowHeight = 10; //on part sur une base 10 standard this.options.fixedRowHeight;


    if(currentRowHeight * (maxRow + 5) < (totalHeight - 10)) { // on prend un peu de marge
      let perfectHeightWithMargin: number = Math.floor((totalHeight - 10) / maxRow);
      this.options.fixedRowHeight = perfectHeightWithMargin -5; // on enlève la marge
      // this.meGridster.curRowHeight = perfectHeight;
      // console.log('curRowHeight', this.options.fixedRowHeight);
   
    } else {
      this.options.fixedRowHeight = 10; // TODO selon le scale
      // console.log('base 10', this.options.fixedRowHeight);
    }

    // console.log('optimizeHeight', totalHeight, maxRow, currentRowHeight, this.options.fixedRowHeight);
    this.options.api?.optionsChanged();
  }

  public generatePDF(e: AlkEvent): void {

    // console.log('utv', this.tabWidgets);
    let elements: PDFPage[] = [];
    let kind: PDF_PAGE_KIND;
    let isHeader: boolean = false;
    let noHead: boolean = false;
    let noFoot: boolean = false;
    let sorted: GridsterWidget[] = [...this.tabWidgets.sort((a, b) => (a.y * 10000 + a.x) - (b.y * 10000 + b.x))];
    sorted.forEach(gw => {
      
      if( gw.instance.widgetKind === WIDGET_KIND.FD_GRID || 
          gw.instance.widgetKind === WIDGET_KIND.PIVOT || 
          gw.instance.widgetKind === WIDGET_KIND.GRID) {
        kind = PDF_PAGE_KIND.HTML;
      } else {
        kind = PDF_PAGE_KIND.IMAGE;
      }

      if(gw.title?.indexOf('header') > -1) {
        isHeader = true;
      } else {
        isHeader = false;
      }

      if(gw.title?.indexOf('noHead') > -1) {
        noHead = true;
      } else {
        noHead = false;
      }

      if(gw.title?.indexOf('noFoot') > -1) {
        noFoot = true;
      } else {
        noFoot = false;
      }


      let pdfPage: PDFPage = {element: gw.instance.elementRef, 
        widget: gw.instance,
        kind,
        isHeader,noHead, noFoot,
        width: gw.instance.elementRef.nativeElement.offsetWidth,
        height: gw.instance.elementRef.nativeElement.offsetHeight
      }
      elements.push(pdfPage);
    });
    
    this.model.excelExportEngine.pdfReport('allkeyme', elements);
  }

  public doHide(item: GridsterWidget): string {
    let result: string = 'unset';
    if(!!item.wco?.hidden) {
      result = 'none';
    }
    // console.log('doHide', result);
    return result;
  }
}
